<template>
	<div class="my-order-page">
		<!-- ===== 标题栏 ===== -->
		<div class="page-header animate__animated  ">
			<el-image :src="require('@/static/CodeBuddyAssets/31270_3509/24.svg')"></el-image>
			<span class="header-title">{{$t('userPageL.txt4')}}</span>
		</div>

		<!-- ===== Tab 切换栏 ===== -->
		<div class="tab-bar animate__animated  ">
			<div
				v-for="(item, index) in tabs"
				:key="index"
				class="tab-item"
				:class="{ 'tab-item--active': activeTab === item.id }"
				@click="activeTab = item.id,packagelistF()"
			>
			<template v-if="item.id==0">{{$t('selPackage.t1')}}</template>
			<template v-if="item.id==1">{{$t('selPackage.t2')}}</template>
			<template v-if="item.id==2">{{$t('selPackage.t3')}}</template>
			</div>
		</div>

		<!-- ===== 搜索筛选区 ===== -->
		<div class="filter-bar animate__animated  ">

			<div class="filter-items">
				
				<div class="filter-month f-ct" v-if="activeTab!=2">
					<!-- 多语言 -->
					<template v-if="$i18n.locale=='zh'">
						<el-select @change="packagelistF" v-model="warehouseIdx" :placeholder="$t('selPackage.t4')" class="form-select">
							<el-option v-for="item in warehouseArr" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</template>
					<template v-if="$i18n.locale=='en'">
						<el-select @change="packagelistF" v-model="warehouseIdx" :placeholder="$t('selPackage.t4')" class="form-select">
							<el-option v-for="item in warehouseArr" :key="item.value" :label="item.nameEn" :value="item.value"></el-option>
						</el-select>
					</template>
					<el-image :src="require('@/static/sel/15.svg')"></el-image>
				</div>
				
				<div class="shaixuanFrom f-bct">
					<div class="iptBox">
						<el-image :src="require('@/static/sel/6.svg')"></el-image>
						<el-input v-model="query" :placeholder="$t('olist.t40')"></el-input>
					</div>
					<div class="action-bar1">
						<el-button type="primary" class="submit-btn" @click="packagelistF">{{$t('olist.t2')}}</el-button>
					</div>
				</div>

				<!-- 下单时间范围 -->
				<div class="filter-date">
					<span class="date-label">{{$t('olist.t3')}}</span>
					<el-date-picker
						@change="packagelistF"
						value-format="yyyy-MM-dd"
						v-model="searchForm.dateRange"
						type="daterange"
						range-separator="-"
						:start-placeholder="$t('olist.t4')"
						:end-placeholder="$t('olist.t4')"
						prefix-icon=" "
					></el-date-picker>
					<el-image :src="require('@/static/sel/14.svg')"></el-image>
				</div>

				<!-- 月份选择 -->
				<div class="filter-month f-ct" v-if="activeTab==2">
					<el-select @change="packagelistF" v-model="searchForm.month">
						<el-option :label="$t('olist.t5')" value="0"></el-option>
						<el-option :label="$t('olist.m1')" value="1"></el-option>
						<el-option :label="$t('olist.m2')" value="2"></el-option>
						<el-option :label="$t('olist.m3')" value="3"></el-option>
						<el-option :label="$t('olist.m4')" value="4"></el-option>
						<el-option :label="$t('olist.m5')" value="5"></el-option>
						<el-option :label="$t('olist.m6')" value="6"></el-option>
						<el-option :label="$t('olist.m7')" value="7"></el-option>
						<el-option :label="$t('olist.m8')" value="8"></el-option>
						<el-option :label="$t('olist.m9')" value="9"></el-option>
						<el-option :label="$t('olist.m10')" value="10"></el-option>
						<el-option :label="$t('olist.m11')" value="11"></el-option>
						<el-option :label="$t('olist.m12')" value="12"></el-option>
					</el-select>
					<el-image :src="require('@/static/sel/15.svg')"></el-image>
				</div>
				
				<div class="action-bar1">
					<el-button type="primary" class="submit-btn" @click="link('/userPageLab/packageAdd')">{{$t('selPackage.t5')}}</el-button>
				</div>
				
			</div>
		</div>

		<!-- ===== 数据表格 (Element UI) ===== -->
		<div class="table-wrap animate__animated   newTable">
			<!-- th -->
			<div class="title f-ct">
				<div class="t1">{{$t('selPackage.t6')}}</div>
				<template v-if="activeTab==2">
					<div class="t2w">{{$t('selPackage.t7')}}</div>
				</template>
				<template v-else>
					<div class="t2">{{$t('selPackage.t7')}}</div>
					<div class="t3">{{$t('selPackage.t8')}}</div>
				</template>
				<div class="t4">{{$t('selPackage.t9')}}</div>
				<div class="t5">{{$t('selPackage.t10')}}</div>
				<div class="t6">{{$t('selPackage.t11')}}</div>
				<div class="t7">{{$t('selPackage.t12')}}</div>
			</div>
			<!-- 所选信息 -->
			<div class="selAllMsg f-bct" v-if="activeTab==1">
				<div class="left f-ct">
					<el-image class="selImg" @click="selAllPackage()" v-if="isSelAll" :src="require('@/static/add2/68h.png')"></el-image>
					<el-image class="selImg" @click="selAllPackage()" v-else :src="require('@/static/add2/68.png')"></el-image>
					<span>{{$t('selPackage.t13',{num:selNub})}}</span>
				</div>
				<div class="right" @click="goOrderWl">{{$t('selPackage.t14')}}</div>
			</div>
			<!-- 暂无 -->
			<div class="zwBox" v-if="!orderList.length">
				<el-image :src="require('@/static/zw.svg')"></el-image>
				<p>{{$t('selPackage.t15')}}</p>
			</div>
			<!-- 列表 -->
			<div class="goodsItem" v-for="(item,index) in orderList">
				<div class="topBox f-ct">
					<div class="sn f-ct">
						<template v-if="activeTab==1">
							<el-image class="selImg" @click="selPackageF(item,index)" v-if="item.sel" :src="require('@/static/add2/68h.png')"></el-image>
							<el-image class="selImg" @click="selPackageF(item,index)" v-else :src="require('@/static/add2/68.png')"></el-image>
						</template>
						<p>{{$t('selPackage.t16')}}{{item.expressNumber}}</p>
						<el-image class="copyImg" @click="copy_txt(item.expressNumber)" :src="require('@/static/add2/51.png')"></el-image>
						</div>
						<div class="time">{{$t('selPackage.t17')}}{{item.createTime||'?'}}</div>
						<div class="ftype">{{$t('selPackage.t18')}}{{item.warehouse.name||'?'}}</div>
						</div>
						<div class="gmsg f-ct">
						<div class="b1">
						<div class="b1itm flex">
							<el-image v-if="!item.gallery.length" :src="imgDef1" fit="cover"></el-image>
							<el-image v-else :src="item.gallery[0]" fit="cover"></el-image>
							<div class="txtBox">
								<div class="t2 line2">{{item.name||'?'}}</div>
								<div class="t3" v-if="item.goodsTypeName&&item.goodsTypeName.length">{{$t('selPackage.t19')}}{{item.goodsTypeName.join(',')}}</div>
								<div class="t3" v-else>{{$t('selPackage.t19')}}?</div>
							</div>
						</div>
						</div>
						<template v-if="activeTab==2">
						<div class="b2w">{{item.weight||'?'}}kg</div>
						</template>
						<template v-else>
						<div class="b2">{{item.weight||'?'}}kg</div>
						<div class="b3">{{item.pieceNum}}</div>
						</template>
						<div class="b4">{{$t('selPackage.t20')}} {{item.length||'?'}}cm * {{$t('selPackage.t21')}} {{item.width||'?'}}cm * {{$t('selPackage.t22')}}{{item.height||'?'}}cm  {{$t('selPackage.t23')}} {{item.volume||'?'}}m³</div>
						<div class="b5">{{item.createTime}}</div>
						<div class="b6">{{item.putTime||$t('selPackage.t24')}}</div>
						<div class="b7">
						<div class="btnLin" @click="getPakeageHb=true,selGetItem = item" v-if="activeTab==2">{{$t('selPackage.t25')}}</div>
						<div class="btn3" v-else @click="viewOrder(item)">{{$t('selPackage.t26')}}</div>
						</div>
						</div>
			</div>
		</div>

		<!-- ===== 分页 ===== -->
		<div class="pagination-wrap animate__animated  " v-if="activeTab==2">
			<el-pagination
				background
				layout="prev, pager, next, jumper"
				:total="total"
				:page-size="pageSize"
				:current-page.sync="currentPage"
				@current-change="handleCurrentChange"
			></el-pagination>
		</div>
		
		<!-- 领取弹出框 -->
		<el-dialog
			:visible.sync="getPakeageHb"
			width="764px"
			custom-class="add-mark-dialog"
			:show-close="false"
			:close-on-click-modal="false">
			<!-- 自定义头部 -->
			<div slot="title" class="dialog-header">
				<h2 class="dialog-title">{{$t('selPackage.t27')}}</h2>
				<el-image class="dialog-close-icon" :src="require('@/static/sel/20.svg')" @click="getPakeageHb = false"></el-image>
			</div>
			<div class="getPackageFrom">
				<div class="form-item">
					<label class="form-label">{{$t('selPackage.t28')}}</label>
					<div class="form-input-wrap">
						<el-input v-model="expressNumber" :placeholder="$t('selPackage.t29')" size="large"></el-input>
					</div>
				</div>
				<div class="form-item">
					<label class="form-label">{{$t('selPackage.t30')}}</label>
					<div class="form-input-wrap">
						<el-select v-model="maitouSel" :placeholder="$t('selPackage.t4')" class="form-select">
							<el-option v-for="item in maitouOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</div>
				</div>
				<div class="form-item">
					<label class="form-label">{{$t('selPackage.t31')}}</label>
					<div class="form-input-wrap">
						
						<!-- 多语言 -->
						<template v-if="$i18n.locale=='zh'">
							<el-select v-model="categorySel" multiple :placeholder="$t('selPackage.t32')" class="form-select">
								<el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</template>
						<template v-if="$i18n.locale=='en'">
							<el-select v-model="categorySel" multiple :placeholder="$t('selPackage.t32')" class="form-select">
								<el-option v-for="item in categoryOptions" :key="item.value" :label="item.nameEn" :value="item.value"></el-option>
							</el-select>
						</template>
						
					</div>
				</div>
			</div>
			<!-- 底部按钮区 -->
			<div slot="footer" class="dialog-footer">
				<button class="btn-cancel" @click="getPakeageHb = false">{{$t('olist.hb5')}}</button>
				<button class="btn-confirm" @click="submitClaim">{{$t('selPackage.t33')}}</button>
			</div>
		</el-dialog>
		
		<!-- ===== 删除弹出框 ===== -->
		<el-dialog
			:visible.sync="addMarkVisibleDel"
			width="764px"
			custom-class="add-mark-dialog"
			:show-close="false"
			:close-on-click-modal="false">
			<!-- 自定义头部 -->
			<div slot="title" class="dialog-header">
				<h2 class="dialog-title">{{$t('selPackage.t34')}}</h2>
				<el-image class="dialog-close-icon" :src="require('@/static/sel/20.svg')" @click="addMarkVisibleDel = false"></el-image>
			</div>
			<div class="dialog-title1">
				{{$t('selPackage.t35')}}
			</div>
			<!-- 底部按钮区 -->
			<div slot="footer" class="dialog-footer">
				<button class="btn-cancel" @click="addMarkVisibleDel = false">{{$t('olist.hb5')}}</button>
				<button class="btn-confirm" @click="transportOrderremoveByIdF">{{$t('olist.hb9')}}</button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
import {
	packagelist,
	packageremove,
	warehouselist,
	packageunclaimedList,
	packageclaim,
	memberMarklist,
	countrylist,
	packageGoodsTypeList
} from "/src/api/api.js"
export default {
	name: 'MyOrderPage',
	inject: ['reload'],
	data() {
		return {
			// 状态
			activeTab: 1,
			tabs: [
				{txt:'已入库',id:1},
				{txt:'待入库',id:0},
				{txt:'包裹认领',id:2},
			],
			// 搜索
			query:'',
			searchForm: {
				dateRange: '',
				month: '0'
			},
			// 仓库
			warehouseArr:[],
			warehouseIdx:-1,
			// 分页
			currentPage: 1,
			pageSize: 10,
			total: 250,
			// 数据
			orderList: [],
			// 弹出框所选数据
			selItem:'',
			// 弹出框 删除
			addMarkVisibleDel:false,
			// 选择部分
			selNub:0,
			isSelAll:false,
			// 领取弹出框
			getPakeageHb:false,
			selGetItem:'',
			// 表单
			expressNumber:'',
			// 品类
			categoryOptions:[],
			categorySel:[],
			// 唛头
			maitouOptions:[],
			maitouSel:'',
		}
	},
	mounted() {
		if(this.$route.query.status){
			this.activeTab = this.$route.query.status*1
		}
		this.warehouselistGet()
		this.loadCategories()
		this.getmemberMarklist()
	},
	methods: {
		// 申请打包合箱
		goOrderWl(){
			var arr = []
			this.orderList.forEach((item)=>{
				if(item.sel){
					arr.push(item)
				}
			})
			localStorage.setItem('goOrderWl', JSON.stringify(arr));
			this.link('/userPageLab/orderPage',{clear:true})
		},
		// 认领部分
		// 唛头列表
		async getmemberMarklist() {
			const res = await memberMarklist({})
			if (res.code == 200) {
				(res.rows || []).forEach(item => {
					item.label = item.memberMarks
					item.value = item.id
				})
				this.maitouOptions = res.rows
			} else {
				this.Tips(res.msg || this.$t('selPackage.t36'), 'error')
			}
		},
		// 品类
		async loadCategories() {
			const res = await packageGoodsTypeList({})
			if (res.code == 200) {
				(res.rows || []).forEach(item => {
					item.label = item.name
					item.value = item.id
				})
				this.categoryOptions = res.rows
			} else {
				this.Tips(res.msg || this.$t('selPackage.t37'), 'error')
			}
		},
		// 提交认领
		async submitClaim(){
			// 必填验证
			if(!this.expressNumber){
				this.Tips(this.$t('selPackage.t29'));
				return;
			}
			if(!this.categorySel.length){
				this.Tips(this.$t('selPackage.t38'));
				return;
			}
			if(!this.maitouSel){
				this.Tips(this.$t('selPackage.t39'));
				return;
			}
			var data = {
				packageId: this.selGetItem.id,
				expressNumber: this.expressNumber,
				memberMarksId: this.maitouSel,
				goodsType: this.categorySel,
			}
			const res = await packageclaim(data)
			if(res.code==200){
				this.Tips(res.msg)
				this.getPakeageHb = false
				this.selGetItem = ''
				this.expressNumber = ''
				this.maitouSel = ''
				this.categorySel = []
				this.packagelistF()
			}else{this.Tips(res.msg,'error')}
		},
		// 选择数据统计
		selStats(){
			var selNub = 0
			var isSelAll = true
			this.orderList.forEach((item)=>{
				if(!item.sel){
					isSelAll = false
				}else{
					selNub++
				}
			})
			this.selNub = selNub
			this.isSelAll = isSelAll
		},
		// 全选包裹
		selAllPackage(){
			this.isSelAll = !this.isSelAll
			this.orderList.forEach((item)=>{
				item.sel = this.isSelAll
			})
			if(this.isSelAll){
				this.selNub = this.orderList.length
			}else{
				this.selNub = 0
			}
		},
		// 选择包裹
		selPackageF(item,index){
			item.sel = !item.sel
			this.$set(this.orderList,index,item)
			this.selStats()
		},
		// 仓库列表(全部正常的)
		async warehouselistGet(){
			var data = {}
			const res = await warehouselist(data)
			if(res.code==200){
				(res.rows || []).forEach(item => {
					item.label = item.name
					item.value = item.id
				})
				this.warehouseArr = [...res.rows]
				this.warehouseIdx = res.rows[0].id
				this.packagelistF()
			}else{this.Tips(res.msg,'error')}
		},
		// 跳转详情
		viewOrder(item){
			this.link('/userPageLab/packageMsg',{id:item.id})
		},
		// 包裹列表
		async packagelistF(){
			this.selNub=0
			this.isSelAll=false
			var res;
			var data = {}
			
			if(this.activeTab==2){
				data.pageNum = this.currentPage
				data.pageSize = this.pageSize
			}
			
			if(this.query){
				data.query = this.query
			}
			
			if(this.searchForm.month*1){
				var str = ''
				if(this.searchForm.month<10){
					str = '0'+this.searchForm.month
				}
				const utcYear = new Date().getUTCFullYear();
				str = utcYear+'-'+str
				data.queryMonth = str
			}
			
			if(this.activeTab!=2){
				if(this.warehouseIdx!=-1){
					data.warehouseId = this.warehouseIdx
				}
			}else{
				if(this.searchForm.dateRange){
					data.beginTime = this.searchForm.dateRange[0]
					data.endTime = this.searchForm.dateRange[1]
				}
			}
			
			if(this.activeTab==2){}else{
				data.status = this.activeTab*1+1
			}
			
			if(this.activeTab==2){
				res = await packageunclaimedList(data);
			}else{
				res = await packagelist(data);
			}
			
			if(res.code==200){
				res.rows.forEach((item)=>{
					item.sel = false
				})
				this.total = res.total
				this.orderList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 切换分页
		handleCurrentChange(page) {
			this.currentPage = page
			this.packagelistF()
		},
		// 删除按钮
		deleteOrder(item) {
			this.selItem = item
			this.addMarkVisibleDel = true
		},
		async transportOrderremoveByIdF(){
			var res;
			res = await packageremove({
				id:this.selItem.id,
			});
			if(res.code==200){
				this.addMarkVisibleDel = false
				this.Tips(res.msg)
				this.packagelistF()
			}else{this.Tips(res.msg,'error')}
		},
	}
}
</script>

<style lang="scss" scoped>
/* ========== 设计令牌 ========== */
$primary: #0096FF;
$danger: #FC2933;
$text-dark: #333333;
$text-gray: #666666;
$text-muted: #999999;
$text-light: #7D7D89;
$border-color: #F0F0F0;
$page-bg: white;
$header-bg: #FAFAFA;

/* ========== 页面容器 ========== */
.my-order-page {
	width: 15.93rem;           /* 1593px */
	background: $page-bg;
	border-radius: 12px;
	padding: 24px 25px 30px;  /* left:316=292+24 */
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	margin-top: 24px;
}

/* ========== 标题栏 ========== */
.page-header {
	display: flex;
	align-items: center;
	margin-bottom: 22px;       /* 到 tab 的间距 ≈ 160+24-160≈24 */

	.header-icon {
		width: 14px;
		height: 14px;
		flex-shrink: 0;
	}

	.header-title {
		font-size: 20px;
		font-weight: 500;
		color: $text-dark;
		margin-left: 12px;
	}
}

/* ========== Tab 栏 ========== */
.tab-bar {
	display: flex;
	align-items: center;
	// gap: 72px;               /* tab 间距 ≈ 418-328=90，取合理值 */
	// padding-bottom: 16px;
	border-bottom: 1px solid #F5F5F5;
	margin-bottom: 18px;      /* 到筛选区的间距 */

	.tab-item {
		font-size: 18px;
		font-weight: 400;
		color: $text-light;
		cursor: pointer;
		transition: color 0.2s;
		white-space: nowrap;
		padding: 0 24px;
		padding-bottom: 16px;
		position: relative;
		// background: pink;
		margin-right: 24px;
		&::after{
			position: absolute;
			content: '';
			width: 0%;
			height: 4px;
			background: #0096FF;
			border-radius: 4px;
			left: 49%;
			transform: translateX(-50%);
			bottom: 0;
			transition:0.3s;
		}
		&:hover { color: $primary; }

		&--active {
			color: $primary;
			&::after{
				transition:0.3s;
				width: 35%;
			}
			font-weight: bold;
		}
	}
}

/* ========== 筛选栏 ========== */
.filter-bar {
	display: flex;
	align-items: center;
	margin-bottom: 24px;      /* 到表格的间距 = 346-(250+38+50)=8... 实际约24px */

	.filter-icon {
		width: auto;
		height: 26px;
		flex-shrink: 0;
		margin-right: 15px;
		margin-top: 13px;
	}

	.filter-items {
		display: flex;
		align-items: center;
		gap: 16px;            /* 各筛选项间距 */
		flex: 1;
	}
}

/* ---- 输入框 ---- */
.filter-inp {
	width: 652px;
	flex-shrink: 0;
	
		
	::v-deep .el-input {
		width: 100%;
	}

	::v-deep .el-input__inner {
		height: 50px;
		line-height: 48px;
		border-radius: 8px;
		border: none;
		background: #FAFAFA;
		font-size: 16px;
		padding: 0 20px;
		color: #333;
		
		&::placeholder { color: #A0AEC0; letter-spacing: 0.48px; }

		&:focus { background: #F5F5F5; }

		.el-input__prefix { left: 20px; }
		
	}
}

/* ---- 日期范围选择器 ---- */
.filter-date {
	width: 468px;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	background: #f8f8f8;
	border-radius: 8px;
	height: 50px;
	padding: 0 20px;
	box-sizing: border-box;
	// background: pink;
	.date-label {
		font-size: 16px;
		color: #989FAC;
		letter-spacing: 0.48px;
		margin-right: 4px;
		white-space: nowrap;
		flex-shrink: 0;
	}
	
	.el-image{
		width: 20px;
	}

	::v-deep .el-date-editor {
		width: calc(100% - 84px);
		border: none !important;
		background: #f8f8f8;
	}

	::v-deep .el-range-input {
		font-size: 16px;
		color: #333;
		background: transparent;
		width: 110px;

		&::placeholder { color: #989FAC; }
	}

	::v-deep .el-range-separator {
		color: #333;
		width: auto;
		padding: 0 8px;
	}

	::v-deep .el-range__icon,
	::v-deep .el-range__close-icon {
		display: none;
	}

	::v-deep .el-range-editor--medium {
		height: 50px;
	}
}

/* ---- 月份选择器 ---- */
.filter-month {
	width: 235px;
	flex-shrink: 0;
	background: #f8f8f8;
	border-radius: 8px;
	// background: pink;
	::v-deep .el-select {
		width: calc(100% - 40px);
		
		.el-input__inner {
			height: 50px;
			line-height: 48px;
			border-radius: 8px;
			border: none;
			background: #f8f8f8;
			font-size: 16px;
			color: #333;
			padding: 0 35px 0 20px;
			letter-spacing: 0.48px;
			// background: pink;
		}

		.el-input__suffix {
			right: 20px;
		}

		.el-select__caret {
			width: 12px;
			height: 8px;
			&::before { content: none; }
		}

		.el-select__icon {
			width: 12px;
			height: 8px;
			// background: url(~@/static/CodeBuddyAssets/31200_3663/31.svg) no-repeat center/contain;
		}
	}
}

/* ---- 搜索按钮 ---- */
.search-btn {
	width: 116px;
	height: 50px;
	flex-shrink: 0;
	background: $primary;
	border: none;
	border-radius: 8px;
	font-size: 16px;
	font-weight: 400;
	color: white;
	letter-spacing: 0.48px;
	cursor: pointer;
	transition: opacity 0.25s;

	&:hover { opacity: 0.88; }
	&:active { opacity: 1; }
}

/* ========== 表格区域 (Element UI) ========== */
.table-wrap {
	width: 100%;
}

::v-deep .el-table {
	border-radius: 8px;
	overflow: hidden;

	th.el-table__cell,
	td.el-table__cell {
		padding: 0;
	}
}

/* ---- 表头样式 ---- */
::v-deep .order-table-header {
	background-color: $header-bg !important;
	height: 56px !important;
	font-size: 14px !important;
	font-weight: 500 !important;
	color: $text-dark !important;

	.cell {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 56px;
		line-height: normal;
	}
}

/* ---- 单元格样式 ---- */
::v-deep .order-table-cell {
	height: 56px !important;
	font-size: 14px !important;
	font-weight: 400 !important;
	color: $text-gray !important;

	.cell {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 56px;
		line-height: normal;
	}
}

/* ---- 操作列内容 ---- */
.cell-action {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-wrap: wrap;
	gap: 10px;
}

.act-view,
.act-edit,
.act-del {
	font-size: 14px;
	cursor: pointer;
	white-space: nowrap;
	transition: opacity 0.2s;

	&:hover { opacity: 0.7; }
}

.act-view { color: $primary; }
.act-edit { color: $primary; }
.act-del { color: $danger; }
.act-def { color: #999; }

/* ========== 分页（复制 latestNews.vue） ========== */
.pagination-wrap {
	display: flex;
	justify-content: flex-end;
	padding-top: 20px;
	padding-right: 10px;

	::v-deep .el-pagination__editor { margin-right: 12px; }

	::v-deep .el-pagination {
		font-weight: 400;

		.el-pager li {
			min-width: 32px;
			height: 32px;
			line-height: 32px;
			font-size: 12px;
			border-radius: 4px;
			margin: 0 4px;
			color: #2C2C2C;

			&.active {
				background: transparent;
				color: $primary;
				border-color: transparent;
				font-weight: 600;
			}

			&:hover { color: $primary; }
		}

		.btn-prev,
		.btn-next {
			min-width: 32px;
			height: 32px;
			line-height: 32px;
			font-size: 12px;
			border-radius: 4px;

			&:hover { color: $primary; }
		}

		.el-pagination__jump {
			font-size: 12px;
			color: #2C2C2C;
			margin-left: 12px;

			.el-input__inner {
				width: 36px;
				height: 32px;
				line-height: 30px;
				font-size: 12px;
				border-radius: 4px;
				text-align: center;
				padding: 0;

				&:focus { border-color: $primary; }
			}
		}
	}
}

::v-deep .el-pagination.is-background .el-pager li { background: transparent; }
::v-deep .el-pagination.is-background .btn-prev { background: transparent; }
::v-deep .el-pagination.is-background .btn-next { background: transparent; }
::v-deep .el-table th.el-table__cell>.cell { 
	display: flex;
}

.item-thumb{
	width: 36px;
	height: 36px;
	border-radius: 6px;
}

@media (prefers-reduced-motion: reduce) {
	.animate__animated { animation: none !important; }
	* { transition-duration: 0.01ms !important; }
}
.shaixuanFrom{
	// margin-bottom: 12px;
	.iptBox{
		width: 522px;
		height: 50px;
		border-radius: 8px;
		background: #f8f8f8;
		// background: pink;
		padding: 0 20px;
		display: flex;
		align-items: center;
		margin-right: 24px;
		// .el-image{
		// 	width: 16px;
		// }
		::v-deep .el-input {
			width: 400px;
			height: 100%;
			border: none;
			padding-left: 16px;
		}
		::v-deep .el-input__inner {
			text-align: left;
			width: 100%;
			height: 100%;
			line-height: 0.78rem;
			background: transparent;
			border: none;
			font-size: 16px;
			padding: 0;
			&::placeholder {
				color: #A8A8A8;
			}
			&:focus {
				border-color: transparent;
				box-shadow: none;
			}
		}
	}
}
.action-bar1 {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	.submit-btn {
		width: 1.16rem;
		height: 0.50rem;
		border-radius: 0.10rem;
		font-size: 0.18rem;
		font-weight: 500;
		transition: opacity 0.25s ease, transform 0.15s ease;
	
		&:hover {
			opacity: 0.90;
			transform: translateY(-0.01rem);
		}
	
		&:active {
			transform: translateY(0);
			opacity: 1;
		}
	}
}

::v-deep .el-date-editor--daterange {
	justify-content: center;
}

/* ================================================================
   添加唛头弹窗样式
   ================================================================ */

::v-deep .add-mark-dialog {
	border-radius: 8px;
	overflow: hidden;

	.el-dialog__header {
		padding: 0;
		margin: 0;
	}

	.el-dialog__body {
		padding: 30px 32px 20px;
		padding-bottom: 32px;
	}

	.el-dialog__footer {
		padding: 0 32px 28px;
	}
}


/* ---- 弹窗头部 ---- */
.dialog-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 69px;
	background: #f7fafc;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	padding: 0 30px;
	box-sizing: border-box;
}

.dialog-title {
	font-family: 'PingFang SC', sans-serif;
	font-size: 18px;
	font-weight: 500;
	color: #2F3541;
	margin: 0;
	line-height: 1;
}

.dialog-title1 {
	font-family: 'PingFang SC', sans-serif;
	font-size: 18px;
	font-weight: 500;
	color: #2F3541;
	margin: 0;
	line-height: 1;
	text-align: center;
}

.dialog-close-icon {
	width: 16px;
	height: 16px;
	cursor: pointer;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.7;
	}
}


/* ---- 弹窗内容区 ---- */
.dialog-body {
	display: flex;
	flex-direction: column;
}


/* 表单字段行 */
.form-field {
	display: flex;
	align-items: center;
	margin: auto;
	margin-bottom: 20px;
	&:last-child {
		margin-bottom: 0;
	}
}


/* 字段标签 */
.field-label {
	width: 80px;
	text-align: right;
	font-size: 16px;
	font-weight: 400;
	color: #9A9DA7;
	flex-shrink: 0;
	line-height: 45px;
	margin-right: 14px;

	&--center {
		text-align: center;
	}
}


/* 输入框 */
.field-input {
	width: 307px;
	
	.el-input__inner {
		height: 41px;
		line-height: 41px;
		border: 2px solid #E8EDF4;
		border-radius: 8px;
		font-size: 16px;
		color: #333333;
		padding: 0 16px;

		&::placeholder {
			color: #999999;
		}

		&:focus {
			border-color: #0096FF;
		}
	}
}

/* ---- 图片上传区域 ---- */
.form-field--upload {
	align-items: flex-start;

	.upload-container {
		flex: 1;
		width: 307px;
		display: flex;
		flex-wrap: wrap;
		
		::v-deep .el-upload--picture-card {
			width: 90px;
			height: 90px;
			border-radius: 8px;
			border: 1px dashed #DCDFE6;
			background: #FAFAFA;
			line-height: normal;
			display: flex;
			align-items: center;
			justify-content: center;

			&:hover {
				border-color: #0096FF;
				background: #F0F9FF;
			}

			i {
				font-size: 24px;
				color: #C0C4CC;
			}
		}

		::v-deep .el-upload-list--picture-card .el-upload-list__item {
			width: 90px;
			height: 90px;
			border-radius: 8px;
			margin-right: 10px;
			margin-bottom: 10px;
		}
	}

	.upload-tip {
		margin-top: 8px;
		font-size: 12px;
		color: #999999;
		line-height: 1.5;
	}
}

/* 顶部对齐标签 */
.field-label--top {
	line-height: normal;
	padding-top: 8px;
}

/* ---- 弹窗底部按钮区 ---- */
.dialog-footer {
	display: flex;
	align-items: center;
	justify-content: center;
	padding-top: 4px;
}


/* 返回按钮 */
.btn-cancel {
	width: 120px;
	height: 44px;
	background: #E9F6FF;
	border: none;
	border-radius: 6px;
	font-family: 'PingFang SC', sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #0096FF;
	cursor: pointer;
	outline: none;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.85;
	}

	&:active {
		opacity: 1;
	}
}

/* 确认修改按钮 */
.btn-confirm {
	width: 120px;
	height: 44px;
	background: #0096FF;
	border: none;
	border-radius: 6px;
	font-family: 'PingFang SC', sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #FFFFFF;
	cursor: pointer;
	outline: none;
	margin-left: 14px;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.88;
	}

	&:active {
		opacity: 1;
	}
}

// 新版表格
.newTable{
	.title{
		width: 100%;
		height: 57px;
		border: 1px solid #F0F0F0;
		background: #FAFAFA;
		border-radius: 8px;
		color: #333333;
		font-size: 14px;
		.t1{
			padding-left: 32px;
			font-size: 14px;
			width: 420px;
		}
		.t2{
			text-align: center;
			width: 100px;
		}
		.t3{
			text-align: center;
			width: 100px;
		}
		.t2w{
			text-align: center;
			width: 200px;
		}
		.t4{
			text-align: center;
			width: 400px;
		}
		.t5{
			text-align: center;
			width: 160px;
		}
		.t6{
			text-align: center;
			width: 160px;
		}
		.t7{
			text-align: center;
			width: 200px;
		}
	}
	.goodsItem{
		margin-top: 20px;
		border: 1px solid #F0F0F0;
		border-radius: 20px;
		width: 100%;
		.topBox{
			height: 70px;
			width: 100%;
			border-bottom: 1px solid #F0F0F0;
			padding: 0 24px;
			.sn{
				margin-right: 32px;
				p{
					font-size: 16px;
				}
				.selImg{
					width: 22px;
					height: 22px;
					display: block;
					margin-right: 12px;
				}
				.copyImg{
					width: 22px;
					height: 22px;
					display: block;
					margin-left: 12px;
				}
			}
			.time{
				font-size: 16px;
				margin-right: 32px;
			}
			.ftype{
				font-size: 16px;
			}
		}
		.gmsg{
			padding: 24px 0;
			.b1{
				width: 420px;
				padding-left: 24px;
				.b1itm{
					margin-bottom: 24px;
					&:last-child{
						margin-bottom: 0;
					}
				}
				.el-image{
					width: 108px;
					height: 108px;
					border-radius: 4px;
					display: block;
					margin-right: 16px;
				}
				.txtBox{
					width: calc(100% - 124px);
					.t1{
						font-size: 14px;
						color: #0096FF;
					}
					.t2{
						font-size: 16px;
						margin-top: 6px;
						line-height: 1.6;
					}
					.t3{
						color: #666666;
						margin-top: 6px;
					}
				}
			}
			.b2{
				text-align: center;
				font-size: 16px;
				width: 100px;
			}
			.b3{
				text-align: center;
				font-size: 16px;
				width: 100px;
			}
			.b2w{
				text-align: center;
				font-size: 16px;
				width: 200px;
			}
			.b4{
				text-align: center;
				font-size: 16px;
				width: 400px;
			}
			.b5{
				text-align: center;
				font-size: 16px;
				width: 160px;
			}
			.b6{
				text-align: center;
				font-size: 16px;
				width: 160px;
			}
			.b7{
				text-align: center;
				width: 200px;
				div{
					cursor: pointer;
				}
				.btnLin{
					width: 144px;
					height: 44px;
					line-height: 44px;
					border-radius: 4px;
					border: 1px solid #0096FF;
					font-size: 14px;
					color: #fff;
					background: #0096FF;
					text-align: center;
					margin: auto;
					margin-bottom: 6px;
				}
				.btn1{
					width: 144px;
					height: 32px;
					border-radius: 4px;
					border: 1px solid #0096FF;
					font-size: 14px;
					color: #0096FF;
					text-align: center;
					line-height: 32px;
					margin: auto;
					margin-bottom: 6px;
				}
				.btn2{
					width: 144px;
					height: 32px;
					border-radius: 4px;
					border: 1px solid #FC3C3C;
					font-size: 14px;
					color: #FC3C3C;
					text-align: center;
					line-height: 32px;
					margin: auto;
					margin-bottom: 6px;
				}
				.btn3{
					width: 144px;
					height: 32px;
					border-radius: 4px;
					border: 1px solid #DDDFE5;
					font-size: 14px;
					color: #606266;
					text-align: center;
					line-height: 32px;
					margin: auto;
				}
			}
		}
	}
}
.selAllMsg{
	width: 100%;
	margin-top: 24px;
	padding: 16px 24px;
	border-radius: 12px;
	border: 1px solid #F0F0F0;
	.left{
		cursor: pointer;
		.selImg{
			width: 22px;
			height: 22px;
			display: block;
			margin-right: 12px;
		}
		span{
			font-size: 16px;
			color: #333333;
		}
	}
	.right{
		width: 139px;
		height: 50px;
		line-height: 50px;
		border-radius: 8px;
		border: 1px solid #0096FF;
		font-size: 16px;
		color: #fff;
		background: #0096FF;
		text-align: center;
		cursor: pointer;
	}
}
.getPackageFrom{
	.form-item {
		margin-bottom: 28px;
		display: flex;
		flex-wrap: wrap;
		align-items: center;
	}
	.form-label {
		display: block;
		font-size: 16px;
		color: #333;
		font-weight: 400;
		margin-bottom: 10px;
		width: 100px;
	}
	.form-input-wrap {
		width: 600px;
		::v-deep .el-select{
			width: 100%;
		}
	}
}
</style>
